import React from "react";
import { Button, Modal } from "react-bootstrap";
import "../Bid.css";
const WinningBidFaqModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Frequently Asked Questions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-4">
          <p className="winning-cif-que">Does my card get charged?</p>
          <p className="winning-cif">
            A hold in the amount of $1000 is placed on your credit card until we
            receive confirmation that your earnest money deposit has been paid.
            Once we receive confirmation that you have paid the earnest money
            deposit, the hold on your credit card will be removed. If you fail
            to deliver your earnest money deposit, your credit card will be
            charged $1000.A hold in the amount of $1000 is placed on your credit
            card until we receive confirmation that your earnest money deposit
            has been paid. Once we receive confirmation that you have paid the
            earnest money deposit, the hold on your credit card will be removed.
            If you fail to deliver your earnest money deposit, your credit card
            will be charged $1000.
          </p>
        </div>

        <div className="mb-4 ">
          <p className="winning-cif-que">How long is the hold?</p>
          <p className="winning-cif">
            The hold remains until we receive confirmation that your earnest
            money deposit has been paid. You have 48 hours to send your earnest
            money deposit. After 48 hours, the hold will be released if your
            earnest money deposit has been received or your card will be charged
            $1000 if the earnest money deposit hasn't been received.
          </p>
        </div>

        <div>
          <p className="winning-cif-que">Can I cancel my bid?</p>
          <p className="winning-cif">
            If you fail to enter your credit card information within 24 hours,
            the seller may select another bid or relist the property.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button variant="secondary" onClick={handleClose}>
          Close
        </Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default WinningBidFaqModal;
